/**
 * Smooth scroll utility with header offset for anchor navigation
 * Ensures sections are visible when navigating with fixed header
 */

export const smoothScrollTo = (elementId, offset = null) => {
  const element = document.getElementById(elementId);
  if (!element) {
    console.warn(`Element with id "${elementId}" not found`);
    return;
  }

  // Dynamically calculate header height if not provided
  let headerHeight = offset;
  if (headerHeight === null) {
    const header = document.querySelector('header');
    if (header) {
      headerHeight = header.offsetHeight + 20; // Add 20px spacing for visual breathing room
    } else {
      headerHeight = 120; // Fallback with spacing
    }
  } else {
    headerHeight = headerHeight + 20; // Add spacing even if offset is provided
  }

  // Get the section's title element (h1, h2, etc.) or use the section itself
  const titleElement = element.querySelector('h1, h2, h3') || element;
  const elementPosition = titleElement.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

  window.scrollTo({
    top: Math.max(0, offsetPosition), // Ensure we don't scroll to negative position
    behavior: 'smooth'
  });

  // Focus management for accessibility
  element.setAttribute('tabindex', '-1');
  element.focus();
  
  // Remove tabindex after focus to restore normal tab order
  setTimeout(() => {
    element.removeAttribute('tabindex');
  }, 1000);
};

/**
 * Handle anchor link clicks with smooth scroll
 */
export const handleAnchorClick = (e, targetId, offset = null) => {
  e.preventDefault();
  smoothScrollTo(targetId, offset);
  
  // Update URL without triggering scroll
  if (window.history && window.history.pushState) {
    window.history.pushState(null, null, `#${targetId}`);
  }
};

/**
 * Get current section in viewport for active navigation highlighting
 */
export const getCurrentSection = (sections, offset = 100) => {
  const scrollPosition = window.pageYOffset + offset;
  
  for (let i = sections.length - 1; i >= 0; i--) {
    const section = document.getElementById(sections[i]);
    if (section) {
      const sectionTop = section.offsetTop;
      if (scrollPosition >= sectionTop) {
        return sections[i];
      }
    }
  }
  
  return sections[0] || null;
};

